/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3, _TaskPlanificationComponent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Store from "@ember-data/store";
import { action } from "@ember/object";
import { service } from "@ember/service";
import CrudJournalEventBaseComponent from "core/components/forc/abstract/crud-journal-event-based-component";
import JournalEventRetrievalStrategies from "core/components/forc/utils/journal-event-retrieval-strategies";
import { dateLongFormat } from "core/helpers/datepicker-format";
import TaskPlannedJournalEvent from "core/models/task-planned-journal-event";
import { SemeiaMedicSession } from "core/services/session";
import tWithDefault from "core/utils/t-with-default";
import { computeDateTime } from "core/utils/time";
import dayjs from "dayjs";
import { validatePresence } from "ember-changeset-validations/validators";
import { BufferedChangeset } from "ember-changeset/types";
import IntlService from "ember-intl/services/intl";
import { possibleTypes } from "../utils/get-task-types";
let TaskPlanificationComponent = (_class = (_TaskPlanificationComponent = class TaskPlanificationComponent extends CrudJournalEventBaseComponent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "session", _descriptor2, this);
    _initializerDefineProperty(this, "intl", _descriptor3, this);
    _defineProperty(this, "formatter", {
      date: dateLongFormat
    });
    _defineProperty(this, "retrieveJournalEvent", JournalEventRetrievalStrategies.sourceJournalEvent);
    _defineProperty(this, "saveOnProcessed", async function saveOnProcessed() {
      if (!this.isDirty) {
        await this.afterCompleted();
        return;
      }
      await this.onSubmit.perform();
    }.bind(this));
  }
  get hideTitle() {
    // @ts-expect-error we must make CrudJournalEventBaseComponent<> generic
    return this.args.hideTitle;
  }
  get validations() {
    const validations = this.journalEventClass.validations(this.intl);
    validations["occurredAtTime"] = validatePresence({
      presence: true,
      description: "L'heure de la tâche"
    });
    return validations;
  }
  get selected() {
    const selectedTaskType = this.changeset.get("taskType");
    // When we load the form and the selected task type is not in the `possibleTypes` array
    // the task will not be translated in the template.
    // This can happen for some rules which plannify task that are not included in the `possibleTypes`
    // or when the medic enters a "custom" task type
    if (selectedTaskType && !this.possibleTypes.includes(selectedTaskType)) {
      return tWithDefault(this.intl, `task.types.${selectedTaskType}`, selectedTaskType);
    }
    return selectedTaskType;
  }
  computeChangeset() {
    const changeset = super.computeChangeset();
    changeset.on("afterValidation", key => {
      if (!["occurredAtDate", "occurredAtTime"].includes(key)) return;
      const occurredAtDate = changeset.occurredAtDate;
      const occurredAtTime = changeset.occurredAtTime;
      changeset.set("occurredAt", computeDateTime(occurredAtDate, occurredAtTime));
    });
    return changeset;
  }
  onChange() {
    if (this.isNewMode) {
      if (this.isAlloLabo) {
        this.changeset.set("comments", "Fréquence de bio: \nDate de dernière bio: \nFréquence de consultation: \nDate de la prochaine consultation:");
      } else {
        this.changeset.set("comments", "");
      }
    }
  }
  get possibleTypes() {
    return possibleTypes(this.args.patient, this.session.medic);
  }
  get forcDisplayName() {
    return this.hideTitle ? "" : super.forcDisplayName;
  }

  /** @type {boolean} */
  get shouldDisplayProcessButton() {
    return this.isEditMode && !this.isReadOnly;
  }
  get model() {
    // eslint-disable-next-line parog-web/no-use-of-model-in-crud-forc
    const model = this.isNewMode ? this.newModel() : super.model;
    model.occurredAtDate = model.occurredAt;
    model.occurredAtTime = model.occurredAt;
    return model;
  }
  get isAlloLabo() {
    return this.changeset.get("taskType") === "bio-exams-missing";
  }
  newModel() {
    const store = this.store;
    const modelName = this.journalEventClass.modelName;
    const save = async function () {
      await store.createRecord(modelName, this).save();
    };
    const handler = {
      get(target, prop, receiver) {
        if (prop == "save") return save;
        return Reflect.get(target, prop, receiver);
      }
    };
    const attrs = {
      occurredAt: dayjs().hour(12).minute(0).toDate(),
      responsible: this.session.medic
    };
    return new Proxy(attrs, handler);
  }
  get labCareGivers() {
    return this.patient.careGiverAddedJournalEvents.filter(careGiver => careGiver.role == "analistique-laboratory");
  }
}, _defineProperty(_TaskPlanificationComponent, "forcDisplayName", "Tâche"), _defineProperty(_TaskPlanificationComponent, "fullComponentId", "task/edition-form"), _defineProperty(_TaskPlanificationComponent, "journalEventClass", TaskPlannedJournalEvent), _TaskPlanificationComponent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onChange"), _class.prototype), _class);
export { TaskPlanificationComponent as default };